import { styled } from "@mui/material";
import {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "../../../../../AppNavigation/constants";

const RowContainer = styled("div", {
  label: "SurveyNpsCheckboxRowContainer",
})(({ theme }) => ({
  backgroundColor: "#f6f8fa",
  borderRadius: 3,

  border: `1px solid #dcdddc`,
  boxSizing: "border-box",
  width: "auto",
  aspectRatio: "1/1",
  flex: 1,
  transition: "all 0.3s",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  "&.selected": {
    border: `1px solid ${theme.vars.palette.primary.main}`,
    background: theme.vars.palette.primary.main,
    ".row_text": { color: "#fff" },
  },

  ".row_text": {
    flex: 1,
    whiteSpace: "nowrap",
    fontSize: 20,
    textAlign: "center",
    fontWeight: 600,
    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 16,
    },
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 12,
    },
  },
  ".indicator": {
    marginLeft: 10,
    width: 23,
    height: 23,
    objectFit: "contain",
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 18,
      height: 18,
    },
  },

  "&.disabled": {
    ".row_text": {
      opacity: 0.5,
    },
  },
}));

export const SurveyNpsCheckbox = ({
  text,
  onClick,
  selected = false,
  disabled = false,
}: {
  text: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}) => {
  return (
    <RowContainer
      className={`${disabled ? "disabled" : ""} ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div className="row_text">{text}</div>
    </RowContainer>
  );
};

export default SurveyNpsCheckbox;
